import { CssBaseline, ThemeProvider } from "@mui/material";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import React from "react";
import { BrowserRouter as Router } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { SubscriptionProvider } from "./auth/userSubscriptionProvider";
import { UserProvider } from "./auth/UserTokenProvider";
import config from "./config";
import { ConfigProvider } from "./ConfigProvider";
import { AlbumProvider } from "./context/AlbumContext";
import { CurrentlyPlayingProvider } from "./context/CurrentlyPlayingContext";
import useThemeState from "./hooks/useThemeState";
import InternalApp from "./InternalApp";

const stripePromise = loadStripe(config.stripe.publishableKey);

const App: React.FC = () => {
  const { theme, toggleTheme, darkModeEnabled } = useThemeState();
  return (
    <Elements stripe={stripePromise}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <ToastContainer />
        <style>
          {`
          iframe#webpack-dev-server-client-overlay { display: none; }
        `}
        </style>
        <Router basename={config.client.basename}>
          <UserProvider>
            <ConfigProvider>
              <SubscriptionProvider>
                <CurrentlyPlayingProvider>
                  <AlbumProvider>
                    <InternalApp toggleTheme={toggleTheme} darkModeEnabled={darkModeEnabled} />
                  </AlbumProvider>
                </CurrentlyPlayingProvider>
              </SubscriptionProvider>
            </ConfigProvider>
          </UserProvider>
        </Router>
      </ThemeProvider>
    </Elements>
  );
};

export default App;
